import type { CalculationFormTab } from '@/components/calculation-form/type/type'

export const DATABASE_SWITCH_RECOVERY_TABS: CalculationFormTab[] = [
  'ENVIRONMENTAL_DATABASE',
  'BUILDING_BLOCKS'
]

export const isDatabaseSwitchRecoveryTab = (tab: CalculationFormTab) =>
  DATABASE_SWITCH_RECOVERY_TABS.includes(tab)
